import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';

export interface ISettingsDTO extends IBaseEntityDTO {
  key: string;
  value: string;
  system: boolean;
  description: string;
}

export class SettingsDTO extends BaseEntityDTO implements ISettingsDTO {
  key: string;
  value: string;
  system: boolean;
  description: string;

  constructor(data?: Partial<ISettingsDTO>) {
    super(data);
    this.key = data?.key ?? '';
    this.value = data?.value ?? '';
    this.system = data?.system ?? true;
    this.description = data?.description ?? '';
  }
}
